import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import BuildingList from './pages/accommodation/BuildingList';
import BuildingDetails from './pages/accommodation/BuildingDetails';
import FloorDetails from './pages/accommodation/FloorDetails';
import RoomDetails from './pages/accommodation/RoomDetails';
import Dashboard from './pages/admin/Dashboard';
import PropertyStructure from './pages/admin/PropertyStructure';

// Layout wrapper for public pages
const PublicLayout = () => (
  <div className="flex flex-col min-h-screen">
    <Header />
    <main className="flex-grow">
      <Outlet />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/accommodation" element={<BuildingList />} />
          <Route path="/accommodation/:buildingId" element={<BuildingDetails />} />
          <Route path="/accommodation/:buildingId/floor/:floorId" element={<FloorDetails />} />
          <Route path="/accommodation/:buildingId/floor/:floorId/room/:roomId" element={<RoomDetails />} />
        </Route>

        {/* Admin Routes (No public header/footer) */}
        <Route path="/admin" element={<Dashboard />} />
        <Route path="/admin/structure" element={<PropertyStructure />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;